// extracted by mini-css-extract-plugin
export var container = "_s6-0";
export var table = "_s6-2";
export var tableWrapper = "_s6-1";